import { useEffect, useState } from "react";
import "../../styles/Slideshow.css";

// ✅ CORRECT PATHS
import slide1 from "../../assets/slideshow/Banner_Image1-1280.webp";
import slide2 from "../../assets/slideshow/Banner_Image2-1280.webp";
import slide3 from "../../assets/slideshow/Banner_Image3-1280.webp";
import slide4 from "../../assets/slideshow/Banner_Image4-1280.webp";
import slide5 from "../../assets/slideshow/Banner_Image5-1280.webp";

const slides = [slide1, slide2, slide3, slide4, slide5];

export default function Slideshow() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 4500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slideshow-inner" aria-hidden="true">
      {slides.map((img, index) => (
        <img
          key={index}
          src={img}
          alt=""
          className={`slide ${index === active ? "active" : ""}`}
          loading={index === 0 ? "eager" : "lazy"}
          decoding="async"
          fetchPriority={index === 0 ? "high" : "auto"}
        />
      ))}
    </div>
  );
}
